import React from 'react';

const ChatRecommendationContent = ({ recommendation, loading, onPress }) => {
    if (loading || !recommendation) {
        // Loading skeleton
        return (
            <div 
                style={styles.container} 
                onClick={onPress}
            >
                <div style={styles.imagePlaceholder} />
                <div style={{ flexShrink: 1 }}>
                    <div style={styles.label}>Recommendation</div>
                    <div style={styles.loadingBar} />
                </div>
            </div>
        );
    }

    return (
        <div 
            style={styles.container} 
            onClick={onPress}
        >
            {recommendation.image && (
                <img 
                    style={styles.image} 
                    src={recommendation.image} 
                    alt={recommendation.title || 'Recommendation'}
                />
            )}

            <div style={{ flexShrink: 1 }}>
                <div style={styles.label}>Recommendation</div>
                <div style={styles.title}>
                    {recommendation.title}
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        paddingRight: 10,
        borderRadius: 6,
        marginBottom: 10,
        borderLeft: '3px solid #313131',
        cursor: 'pointer',
    },
    image: {
        width: 40,
        height: 40,
        borderRadius: 6,
        marginRight: 8,
        objectFit: 'cover',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    imagePlaceholder: {
        width: 40,
        height: 40,
        borderRadius: 6,
        marginRight: 8,
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    label: {
        fontSize: 14,
        color: '#535353',
    },
    title: {
        fontSize: 14,
        fontWeight: 600,
        color: '#292929',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    loadingBar: {
        width: 150,
        height: 15,
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 4,
        marginTop: 2,
    },
};

export { ChatRecommendationContent };
